import { Avatar, Box, Button, Flex, Heading, IconButton, Text, Tooltip } from '@radix-ui/themes';
import React from 'react'
import TableComponent from '../components/ui-components/TableComponent';
import diaper from '../assets/diaper.svg'
import medication from '../assets/medication.svg'
import bedManagement from '../assets/bed-managent.svg'
import nurseCalling from '../assets/nuses-calling.svg'
import patient from '../assets/patient.svg'
import rolling from '../assets/rolling.svg'
import { IoShieldHalfOutline } from 'react-icons/io5';
import { PiBowlFoodFill } from 'react-icons/pi';
import { TbWashHand } from 'react-icons/tb';

const RolesPage = () => {

    const defaultIcons = [
        {
            logo: diaper,
            label: "Diaper"
        },
        {
            logo: medication,
            label: "Medication"
        },
        {
            logo: bedManagement,
            label: "Bed Management"
        },
        {
            logo: nurseCalling,
            label: "Nurse Calling"
        },
        {
            logo: patient,
            label: "Patient"
        },
        {
            logo: rolling,
            label: "Rolling"
        },



    ]

    const columns = [
        {
            title: 'Sl No',
            key: 'id',
            render: (value, row) => <Text size={2}>{value}</Text>,
        },
        {
            title: 'Roles',
            key: 'role',
            // render: (value, row) => <Flex gap={'2'} align={'center'}>
            //     <Avatar fallback="I"></Avatar>
            //     <Flex direction={'column'}>
            //         <Heading size="1">{value}</Heading>
            //         <Text size={'1'}>institution@gmail.com</Text>
            //     </Flex>
            // </Flex>,
        },
        {
            title: 'Role Alarms',
            key: 'role_alarms',
            render: (value, row) => <Flex gap={'2'}>
                {
                    value?.map((alarm) => {
                        // console.log(alarm)
                        return <Tooltip content={alarm.label}>
                            <Box className={`flex items-center justify-center p-2 bg-green-600  rounded-md`} >
                                {alarm.logo ? <img width={20} src={alarm.logo} alt="" /> : alarm.icon}
                            </Box>
                        </Tooltip>
                    })
                }
            </Flex>,
        },
    ]

    const data = [
        {
            id: '1',
            role: "Admin",
            role_code: "AD123",
            role_alarms: defaultIcons
        },
        {
            id: '2',
            role: "Department",
            role_code: "NM123",
            role_alarms: defaultIcons
        },
        {
            id: '3',
            role: "Care Giver",
            role_code: "CT123",
            role_alarms: defaultIcons
        },
        {
            id: '4',
            role: "Security",
            role_code: "AD123",
            role_alarms: [{
                logo: undefined,
                label: "Security",
                icon: <IoShieldHalfOutline fontSize={20} color='white' />
            }]
        },
        {
            id: '5',
            role: "Food",
            role_code: "NM123",
            role_alarms: [{
                logo: undefined,
                label: "Food",
                icon: <PiBowlFoodFill fontSize={20} color='white' />
            },]
        },
        {
            id: '6',
            role: "Laundery",
            role_code: "CT123",
            role_alarms: [{
                logo: undefined,
                label: "Laundery",
                icon: <TbWashHand fontSize={20} color='white' />
            }]
        },
    ];


    return (
        <Flex direction={'column'} gap={'2'} >
            <Flex justify={'between'}>
                {/* <CreateInstitution /> */}
            </Flex>
            <TableComponent
                dataStructure={data}
                columns={columns}
            />
        </Flex>
    )
}

export default RolesPage;